import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 特定商取引法に基づく表記 返品・交換
 */
export class SctActExchange extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): SctActExchange {
    return new SctActExchange(value);
  }
}
